import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f3980b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-menu" }
const _hoisted_2 = { class: "profile-menu__list" }
const _hoisted_3 = { class: "profile-menu__list" }
const _hoisted_4 = { class: "profile-menu__count profile-menu__count--accent" }
const _hoisted_5 = { class: "profile-menu__count profile-menu__count--accent count" }
const _hoisted_6 = { class: "profile-menu__count profile-menu__count--accent count" }
const _hoisted_7 = {
  key: 1,
  class: "profile-menu__list-item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/manage",
  class: "profile-menu__link"
}, " Администрирование ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "profile-menu__list" }
const _hoisted_11 = { class: "profile-menu__list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: "profile-menu__list-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_router_link, {
          class: "profile-menu__link",
          to: {
            name: 'c-profile',
            params: {
              companyLogin: _ctx.companyLogin,
            },
          }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Профиль ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", {
        class: "profile-menu__list-item",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_router_link, {
          class: "profile-menu__link",
          to: { name: 'c-cart' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Корзина "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.orderItemsQuantity), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", {
        class: "profile-menu__list-item profile-menu__list-item--favorites",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createElementVNode("div", {
          class: "profile-menu__link",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterByFavorites && _ctx.filterByFavorites(...args)))
        }, [
          _createTextVNode(" Избранное "),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.favoritesCount), 1)
        ])
      ]),
      (_ctx.authStore.ordersInDeliveryCount)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "profile-menu__list-item profile-menu__list-item--favorites",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_component_router_link, {
              class: "profile-menu__link",
              to: { name: 'c-orders-in-delivery' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Доставляется "),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.authStore.ordersInDeliveryCount), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        class: "profile-menu__list-item",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_router_link, {
          class: "profile-menu__link",
          to: { name: 'c-orders-history' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Мои заказы ")
          ]),
          _: 1
        })
      ]),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_10, [
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("span", {
          class: "profile-menu__list-item-exit",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('logout')))
        }, " Выход ")
      ])
    ])
  ])), [
    [_directive_click_outside, () => _ctx.$emit('close')]
  ])
}